import { z } from 'zod';

const policyIdSchema = z.coerce.number().int().positive();

export function parsePolicyId(value: unknown): number | null {
  const result = policyIdSchema.safeParse(value);

  return result.success ? result.data : null;
}
